<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <institute-select
          title="Coverage"
          :startMap="true"
          :hidePrice="!pays"
          @select="
            $store.commit('setInitInstitute', $event);
            $router.push('/verification/new');
          "
        />
      </div>
    </div>
    <!--
    <div class="row">
      <div class="col-sm-12">
        <div class="card" v-loading="selecting" element-loading-spinner="qc-spinner">
          <div class="card-header">
            <h4 class="card-title">Coverage</h4>
            
            <div class="category">View our coverage or start a new verification by selecting a country below<button v-if="region" @click.prevent="region = null" class="btn pull-right">Back to map</button></div>
          </div>
          <div class="card-content row">
            <transition name="el-fade-in-linear" mode="out-in">
              <coverage-map key="MAP" v-if="!region" class="col-sm-12" @selectRegion="region = $event" />
              <div key="SELECT" v-else class="col-md-12">
                <institute-table :region="region" @selecting="selecting = $event" @selectInstitute="$store.commit('setInitInstitute', $event); $router.push('/verification/new')" />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>
<script>
import CoverageMap from "src/views/Verifications/components/CoverageMap";
import InstituteTable from "src/views/Verifications/components/InstituteTable";
import InstituteSelect from "src/views/Verifications/components/InstituteSelect";

export default {
  name: "coverage",
  components: {
    CoverageMap,
    InstituteTable,
    InstituteSelect,
  },
  props: {
    initRegion: { type: String, default: null },
  },
  data() {
    return {
      map: null,
      mapData: null,
      mapRegion: "world",
      mapLoading: false,
      selecting: false,
      region: this.initRegion ? { id: this.initRegion } : null,
    };
  },
  mounted() {},
  computed: {
    pays() {
      // if(this.application && !this.application.applicantPays) {
      //   return false
      // } else {
      return (
        this.$store.state.paymentType == "CARD" ||
        this.$store.state.paymentType == "INVOICE"
      );
      // }
    },
  },
  methods: {},
};
</script>
